// extracted by mini-css-extract-plugin
module.exports = {"AppMain":"app_AppMain__J1xp6","AppWrapper":"app_AppWrapper__2T025"};